<!--
/*******************************************************************************
*@ 화면명     : SmsEmailCertn
*@ 화면설명   : SMS/E-MAIL 인증
*@ 사용전문   : RBF0409E40 - 고객정보조회
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <div class="scroll">
      <!--"MOTP-01-05-06-01": "본인 인증"-->
      <!--"MOTP-01-05-05-02": "본인 인증을 위해서는 영업점에서 등록한 개인 휴대폰 번호 또는 이메일 정보를 통해 인증코드를 입력해 주셔야 합니다."-->
      <contents-header
        :bg-type="true"
        :no-radius="true"
        :tabs="true"
        title="MOTP-01-05-06-01"
        description="MOTP-01-05-05-02"
      >
        <template #tab>
          <div class="tabs bg-type" id="tabs">
            <button
              class="tab-button tab-button--type1"
              v-for="(tab, index) in tabs"
              :class="{ active: currentTab === index, disabled : index == isTabDisabled }"
              @click="FN004(index)"
              :key="index"
            >
              <i class="icon icon-attestation" />
              <span class="btn-text">{{ tab }}</span>
            </button>
          </div>
        </template>
      </contents-header>

      <article class="contents">
        <div v-show="currentTab === 0">
          <div class="form">
            <div class="form-row">
              <div class="item-tit">{{ /*휴대폰 번호(인증)*/ $t("MOTP-01-05-05-03") }}</div>
              <div class="item-desc">
                <!-- 전화번호 저장 O [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                <div class="input-text-field">
                  <input
                    type="text"
                    id="name"
                    class="form-control"
                    :value="_.isEmpty(getSendCetrNo.in.certnNatnlCd) ? '-' : getSendCetrNo.in.certnNatnlCd"
                    disabled
                  />
                </div>
                <div class="input-text-field">
                  <input
                    type="text"
                    id="name"
                    class="form-control"
                    :value="_.isEmpty(getSendCetrNo.in.certnCphnNo) ? '-' : getSendCetrNo.in.certnCphnNo"
                    disabled
                  />
                </div>
              </div>
              <div class="item-desc">
                <div
                  class="item-desc"
                  v-if="_.isEmpty(getSendCetrNo.in.smsUseYn) || getSendCetrNo.in.smsUseYn === '0'"
                >
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="checkbox01"
                      id="checkbox01"
                      class="form-check-input"
                      v-model="getSendCetrNo.in.certnCnsntYn"
                      :checked="getSendCetrNo.in.certnCnsntYn === '1' ? 'checked' : ''"
                    />
                    <label
                      for="checkbox01"
                      class="form-check-label"
                    >{{ /*인증 문자 수신에 동의합니다.*/ $t("MOTP-01-05-01-05") }}</label>
                  </div>
                </div>
                <!-- 전화번호 저장 O [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                <div class="info info-help" @click="type = true">
                  <i class="icon icon-help" />
                  {{ /*휴대폰 번호가 변경 되었나요?*/ $t("MOTP-01-05-05-04") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="currentTab === 1">
          <div class="form">
            <div class="form-row">
              <div class="item-tit">{{ /*-이메일 주소*/ $t("MOTP-01-05-06-03") }}</div>
              <div class="item-desc form-multi-group">
                <div class="item-desc">
                  <div class="form-text-field email">
                    <div class="input-text-field">
                      <input
                        type="text"
                        id="name"
                        class="form-control"
                        :value="getRBF0409E40.out.success.emad1 === '' ? '-' : getRBF0409E40.out.success.emad1"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div class="item-desc">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      name="checkbox01"
                      id="checkbox01"
                      class="form-check-input"
                      v-on:click="FN008($event)"
                      :checked="getRBF0409E40.out.success.emailRecvCnsntYn === '1' ? 'checked' : ''"
                    />
                    <label
                      for="checkbox01"
                      class="form-check-label"
                    >{{ /*인증 메일 수신에 동의합니다.*/ $t("MOTP-01-05-06-12") }}</label>
                  </div>
                  <div class="info info-help" @click="type = true">
                    <i class="icon icon-help" />
                    {{ /*-이메일 주소가 변경 되었나요?*/ $t("MOTP-01-05-06-04") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 전화번호 저장 O [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
        <div class="form">
          <div class="form-row">
            <button
              :class="FN002()"
              v-on:click="FN001()"
            >{{ /*인증코드 요청, 인증코드 재발송 */ this.isFirsrSend === true ? $t("MOTP-01-05-06-05") : $t("MOTP-01-05-06-06") }}</button>
          </div>

          <div class="validate">
            <article v-if="getSendCetrNo.messageForTimeOut === true">
              <!-- <article>인증 코드 입력 시간이 초과하엿습니다.</article>
              <article>인증 코드 발송 요청을 다시해주시기 바랍니다.</article>-->
              <!-- "MOTP-01-05-09-02": "인증코드 입력 시간이 초과하였습니다.<br/>인증 코드 발송 요청을 다시해주시기  바랍니다."-->
              <span v-html="$t('MOTP-01-05-09-02')"></span>
            </article>
            <!-- 로컬/개발환경에서만 내려옴.. -->
            <article
              v-if="getSendCetrNo.out.success.certnNo.length === 6"
            >(local/dev 인증코드) {{ getSendCetrNo.out.success.certnNo }}</article>
          </div>

          <!-- 인증코드 [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
          <div v-if="getSendCetrNoConfirm.in.certnNoSerno !== ''" class="form-row">
            <div class="item-tit">{{ /*인증코드 입력*/ $t("MOTP-01-05-05-07") }}</div>
            <div class="item-desc">
              <div class="form-text-field">
                <div class="input-text-field timer-type2">
                  <input
                    type="tel"
                    id="name"
                    class="form-control"
                    :placeholder="$t('MOTP-01-05-05-08')"
                    maxlength="6"
                    :value="getSendCetrNoConfirm.in.certnNo"
                    @input="$store._mutations['auth/commMotpCertn/mut001_commMotpCertn'][0]({ key: 'certnNo', value: $event.currentTarget.value })"
                  />
                  <span class="timer">
                    {{
                    Math.floor(this.$store.state.auth.commMotpCertn.sendTime / 60) + " : " + _.padStart(Math.floor(this.$store.state.auth.commMotpCertn.sendTime % 60), 2, "0")
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 인증코드 [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
        </div>
        <!-- 전화번호 저장 O [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
      </article>
    </div>

    <!-- 이전/인증하기 O [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
    <div class="btn-area--full fixed">
      <button class="btn md gray" v-on:click="FN005">{{ /*이전*/ $t("MOTP-01-05-10-07") }}</button>
      <button
        :class="`btn md ${this.getSendCetrNoConfirm.in.certnNoSerno !== '' && this.getSendCetrNoConfirm.in.certnNo.length === 6 ? 'normal' : 'disabled'}`"
        @click="FN003"
      >{{ /*인증하기*/ $t("MOTP-01-05-06-10") }}</button>
    </div>
    <!-- 이전/인증하기 O [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->

    <!-- Toast 인증번호가 발송되었습니다. -->
    <Toast />

    <!-- action sheet 들어 가는 곳 -->
    <!-- "MOTP-01-05-08-01": "휴대폰/이메일 변경 안내"-->
    <sms-email-info-pop :opened.sync="type" />
    <!--// end -->
  </article>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Common from "@/components/basic/Common";
import Toast from "@/components/page/auth/Toast";
import SmsEmailInfoPop from "@/components/page/auth/SmsEmailInfoPop";

export default {
  name:"SmsEmailCertn",
  extends: Common,
  props: {
    bizDscd: {
      type: String,
      required: true,
    },
    successFnc: {
      type: Function,
      required: true,
    },
    failFnc: {
      type: Function,
      required: false,
    },
    beforeRouterName: {
      type: String,
      required: true,
    },
  },
  components: {
    Toast,
    SmsEmailInfoPop
  },
  created() {
    this.$log.info("SmsEmailCertn - SMS/EMAIL 인증");
    if (this.getRBF0409E40.out.success.emad1 == "") {
      this.isTabDisabled = 1
    }
  },
  mounted() {},
  updated() {},
  data() {
    return {
      currentTab: 0,
      tabs: ["Mobile", "E-Mail"],
      type: false,
      items: [],
      isFirsrSend: true,
      isTabDisabled: -1
    };
  },
  computed: {
    ...mapGetters("auth/commMotpCertn", ["getRBF0409E40", "getSendCetrNo", "getSendCetrNoConfirm"]),
  },
  methods: {
    ...mapActions("auth/commMotpCertn", ["act002_commMotpCertn", "act006_commMotpCertn", "act007_commMotpCertn", "act_setComponent"]),
    /**
     * 인증코드 요청버튼 클릭시
     */
    FN001: function () {
      if (this.currentTab === 0) {
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.msgSendPtrnCd = "1";
      } else if (this.currentTab === 1) {
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.msgSendPtrnCd = "2";
      }
      this.isFirsrSend = false;
      this.act002_commMotpCertn();
    },
    /**
     * 인증코드 요청 버튼 class 컨트롤
     */
    FN002: function () {
      let rtn = "btn lg inline disabled";
      // sms
      if (this.currentTab === 0) {
        if (!_.isEmpty(this.getSendCetrNo.in.certnNatnlCd) && !_.isEmpty(this.getSendCetrNo.in.certnCphnNo) && this.getSendCetrNo.in.certnCnsntYn == "1") {
          rtn = "btn lg inline";
        }
        // email
      } else if (this.currentTab === 1) {
        if (this.getRBF0409E40.out.success.emad1 !== "" && this.getRBF0409E40.out.success.emailRecvCnsntYn == "1") {
          rtn = "btn lg inline";
        }
      }
      return rtn;
    },
    /**
     * 인증하기 버튼 클릭시..
     */
    FN003: async function () {
      this.$store.state.auth.commMotpCertn.sendCetrNoConfirm.in.bizDscd = this.bizDscd;
      const result = await this.act007_commMotpCertn();

      if (result === "success") {
        if (!_.isNil(this.successFnc)) {
          this.successFnc();
        }
      }
    },
    /**
     * 탭클릭시..
     */
    FN004: function (index) {
      if (this.isTabDisabled != index) {
        this.currentTab = index;
        this.isFirsrSend = true;
        this.act006_commMotpCertn();
      }
    },
    /**
     * 이전 버튼 클릭시..
     */
    FN005: function () {
      this.act_setComponent("SelfCertnComm");
    },

    /**
     * Email 수신동의 checkbox 클릭시..
     */
    FN008: function (e) {
      if (e.currentTarget.checked === true) {
        this.$store._mutations["auth/commMotpCertn/mut002_commMotpCertn"][0]({ key: "recvCnsntYn", value: "1" });
        this.getRBF0409E40.out.success.emailRecvCnsntYn = "1";
      } else {
        this.$store._mutations["auth/commMotpCertn/mut002_commMotpCertn"][0]({ key: "recvCnsntYn", value: "0" });
        this.getRBF0409E40.out.success.emailRecvCnsntYn = "0";
      }
    },
  },
};
</script>